import { render, staticRenderFns } from "./average.vue?vue&type=template&id=a36d6310&scoped=true"
import script from "./average.vue?vue&type=script&lang=js"
export * from "./average.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d6310",
  null
  
)

export default component.exports